export const GET_STARTED_en = "Get started";
export const START_MONETIZING_en = "Start monetizing";
export const BOOK_A_DEMO_en = "Book a Demo";
export const START_FOR_FREE_en = "Start for free";
export const START_NOW_en = "Start now";
export const LEARN_MORE_en = "Learn more";
export const VISIT_HELP_CENTRE_en = "Visit help centre";

export const cookiesCopies_en = {
  description:
    "We use cookies to personalise your experience and to analyse our website traffic. By continuing to use our website, you consent to our cookies.",
  ctas: {
    ACCEPT_COOKIES: "Accept cookies",
    VIEW_PRIVACY_POLICY: "View privacy policy",
  },
};

export type CookiesCopiesType = typeof cookiesCopies_en;
